import { createContext } from "react";
import Cookies from "js-cookie";
const SidebarContext = createContext();

export default function Sidebar({ children }) {
  let kiosk_details = {}

  let kiosk_detailsCookie = Cookies.get('kiosk_details');

  if (kiosk_detailsCookie) {
    try {
      kiosk_details = JSON.parse(kiosk_detailsCookie);
    } catch (error) {
      console.log('Error parsing kiosk_details cookie:', error);
    }
  }
  return (
    <SidebarContext.Provider value={{}}>
      <aside className="h-screen shadow-md transition-all duration-300" id="sidebar">
        <nav className="h-full flex flex-col border-r shadow-sm">
          <div className="p-3 pb-1 flex justify-center items-center">
            <img
              src={kiosk_details?.image || "https://yt3.googleusercontent.com/RlgPneEAZBw67tgsuNDnDbs3JTvffm2mhE31mxpSLbNVBOA7mPWVsdHe-EBApvrTM2krFkujjQ=s160-c-k-c0x00ffffff-no-rj"}
              alt="Logo"
              className="w-11 h-11 object-contain"

            />
          </div>
          <ul className="flex-1 px-3 mt-10">{children}</ul>
        </nav>
      </aside>
    </SidebarContext.Provider>
  );
}

export function SidebarItem({ icon, text, active, onClick }) {
  return (
    <li
      className={`relative flex items-center py-2 px-3 my-1 font-medium rounded-md cursor-pointer transition-colors group
        ${active ? "text-[color:var(--themePrimaryColor,#75623F)] bg-[color:var(--themeSurfaceColor, #FDFDFD)]" : "hover:bg-[color:var(--themeSecondaryColor,#D4CEC3)] text-brown-200"}`}
      onClick={onClick}
    >
      {icon}

      <div
        className="absolute left-full rounded-md px-12 py-2 ml-2 bg-amber-50 text-brown-200 text-ml font-medium
        invisible opacity-0 -translate-x-3 transition-all group-hover:visible group-hover:opacity-100 group-hover:translate-x-0"
      >
        {text}
      </div>
    </li>
  );
}

export function SidebarItemGroup({ icon, text, children, active }) {
  return (
    <li
      className={`relative flex items-center py-2 px-3 my-1 font-medium rounded-md cursor-pointer transition-colors group
        ${active ? "text-[color:var(--themePrimaryColor,#75623F)] bg-[color:var(--themeSurfaceColor, #FDFDFD)]" : "hover:bg-[color:var(--themeSecondaryColor,#D4CEC3)] text-brown-200"}`}
    >
      {icon}

      <div
        className="absolute left-full rounded-md px-4 py-2 ml-2 bg-amber-50 text-brown-200 text-ml font-medium
        invisible opacity-0 -translate-x-3 transition-all group-hover:visible group-hover:opacity-100 group-hover:translate-x-0 z-50 flex flex-col gap-2 min-w-[150px] shadow-lg border border-[#D4CEC3]"
      >
        <div className="font-bold border-b border-[#D4CEC3] pb-1 mb-1 text-[color:var(--themePrimaryColor,#75623F)]">{text}</div>
        <ul className="flex flex-col gap-1 w-full">
          {children}
        </ul>
      </div>
    </li>
  );
}
